import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, withKeys as _withKeys, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/images/empty-state.png'


const _withScopeId = n => (_pushScopeId("data-v-8fc6ce6e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  "data-testid": "returns-page-load-more-section",
  class: "load-more-action ion-text-center"
}
const _hoisted_2 = {
  key: 1,
  "data-testid": "returns-page-empty-state",
  class: "empty-state"
}
const _hoisted_3 = { key: 0 }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "empty state"
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_menu_button = _resolveComponent("ion-menu-button")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_searchbar = _resolveComponent("ion-searchbar")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_segment_button = _resolveComponent("ion-segment-button")!
  const _component_ion_segment = _resolveComponent("ion-segment")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ReturnListItem = _resolveComponent("ReturnListItem")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_refresher_content = _resolveComponent("ion-refresher-content")!
  const _component_ion_refresher = _resolveComponent("ion-refresher")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_header, { translucent: true }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_toolbar, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_menu_button, {
                "data-testid": "returns-page-menu-btn",
                slot: "start"
              }),
              _createVNode(_component_ion_title, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.translate("Returns")), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createElementVNode("div", null, [
            _createVNode(_component_ion_searchbar, {
              "data-testid": "returns-page-search-input",
              placeholder: _ctx.translate('Search returns'),
              modelValue: _ctx.queryString,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.queryString) = $event)),
              onKeyup: _cache[1] || (_cache[1] = _withKeys(($event: any) => {_ctx.queryString = $event.target.value; _ctx.getReturns()}, ["enter"]))
            }, null, 8, ["placeholder", "modelValue"]),
            _createVNode(_component_ion_segment, {
              "data-testid": "returns-page-segment",
              modelValue: _ctx.selectedSegment,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedSegment) = $event)),
              onIonChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.segmentChanged()))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_segment_button, {
                  "data-testid": "returns-page-open-tab",
                  value: "open"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_label, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.translate("Open")), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_segment_button, {
                  "data-testid": "returns-page-completed-tab",
                  value: "completed"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_label, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.translate("Completed")), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, null, {
        default: _withCtx(() => [
          _createElementVNode("main", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.returns, (returnShipment) => {
              return (_openBlock(), _createBlock(_component_ReturnListItem, {
                key: returnShipment.shipmentId,
                returnShipment: returnShipment
              }, null, 8, ["returnShipment"]))
            }), 128)),
            (_ctx.returns.length < _ctx.returnsTotal)
              ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                  _createVNode(_component_ion_button, {
                    "data-testid": "returns-page-load-more-btn",
                    fill: "outline",
                    color: "dark",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.loadMoreReturns()))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_icon, {
                        icon: _ctx.cloudDownloadOutline,
                        slot: "start"
                      }, null, 8, ["icon"]),
                      _createTextVNode(" " + _toDisplayString(_ctx.translate("Load more returns")), 1)
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true),
            (!_ctx.returns.length && !_ctx.fetchingReturns)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  (_ctx.showErrorMessage)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(_ctx.translate("No results found")), 1))
                    : _createCommentVNode("", true),
                  _hoisted_4,
                  _createElementVNode("p", null, _toDisplayString(_ctx.translate("There are no returns to receive")), 1),
                  _createVNode(_component_ion_button, {
                    "data-testid": "returns-page-refresh-btn",
                    fill: "outline",
                    color: "dark",
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.refreshReturns()))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_icon, {
                        icon: _ctx.reload,
                        slot: "start"
                      }, null, 8, ["icon"]),
                      _createTextVNode(" " + _toDisplayString(_ctx.translate("Refresh")), 1)
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true),
            _createVNode(_component_ion_refresher, {
              "data-testid": "returns-page-refresher",
              slot: "fixed",
              onIonRefresh: _cache[6] || (_cache[6] = ($event: any) => (_ctx.refreshReturns($event)))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_refresher_content, {
                  pullingIcon: "crescent",
                  refreshingSpinner: "crescent"
                })
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}